module.exports = __webpack_public_path__ + "static/media/pneu.428b337f.svg";